import Player from "source/app/domain/Player";
import { GetAheadByTime } from "source/app/presentation/Header/ProgressBar/Helpers/CalculateTodaysProgress";

export function GetStarsBackgroundValue(kipsToday: number, kipsTarget: number) {
    if (Player.isGoalTrackingDisabled) {
        return 100;
    }

    const aheadByTime = GetAheadByTime(kipsToday, kipsTarget);
    const aheadByMinutes = aheadByTime.hours * 60 + aheadByTime.minutes;
    const value = (aheadByMinutes / Player.aheadAfterMinutes) * 100;
    return value;
}
